export default __webpack_public_path__ + "static/media/라탄클래스_모바일.98e545da.jpg";